import React from 'react';
import logo from '../logo.svg';

const styleProps: React.CSSProperties = {
};

const Logo: React.VFC = () => <img src={logo} className="App-logo" alt="logo" style={styleProps} />;

export default Logo;
